export const REQUESTED = 'PAYMENT_REQUESTED';
export const FAILED = 'PAYMENT_FAILED';
export const SUCCESSFUL = 'PAYMENT_SUCCESSFUL';
export const CLIENT_TOKEN = 'PAYMENT_CLIENT_TOKEN';
export const TRANSACTION_SUCCESS = 'PAYMENT_TRANSACTION_SUCCESS';




// WEBPACK FOOTER //
// ./src/containers/Payment/actionTypes.js